import { Link } from 'react-router-dom';
import { movies } from '@/mocks/data';
import MovieCard from '@/components/base/MovieCard';

export default function HotPicks() {
  const hotMovies = movies.filter((m) => m.hot).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">全网最热影视，大家都在看</p>
          </div>
          <Link
            to="/category/dianying"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {hotMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>
      </div>
    </section>
  );
}